export interface ChartStar { x: number; y: number; searchX: number; searchY: number }
export interface StarChart { name: string; stars: ChartStar[]; edges: [number, number][]; tray: number[] }
const chartStars = (points: [number, number][]): ChartStar[] => points.map(([x,y],id) => ({
  x,y, searchX:8+id*84/(points.length-1), searchY:23+((id*31+points.length*7)%52),
}));

/** Imagined constellations, not astronomical charts. Coordinates use the play surface's percentages. */
export const starCharts: StarChart[] = [
  { name:"纸鸢", stars:chartStars([[50,16],[26,40],[50,62],[74,40],[40,82]]),
    edges:[[0,1],[1,2],[2,3],[3,0],[2,4]], tray:[3,0,4,1,2] },
  { name:"归舟", stars:chartStars([[18,54],[37,76],[72,76],[86,54],[53,18],[53,54]]),
    edges:[[0,1],[1,2],[2,3],[3,0],[4,5],[4,0],[4,3]], tray:[4,1,5,0,3,2] },
  { name:"飞鸟", stars:chartStars([[12,34],[29,44],[50,32],[71,44],[88,34],[50,59],[50,81]]),
    edges:[[0,1],[1,2],[2,3],[3,4],[1,5],[5,3],[5,6]], tray:[5,2,6,0,4,1,3] },
];

export const SKY_WIDTH = 2.2;
export function clampPan(value: number) { return Number.isFinite(value) ? Math.max(0,Math.min(1,value)) : 0.5; }
export function getSearchScreenX(x: number, pan: number) { return x*SKY_WIDTH-clampPan(pan)*(SKY_WIDTH-1)*100; }
export function inSearchWindow(star: ChartStar, pan: number) {
  const x=getSearchScreenX(star.searchX,pan);
  return x>=14 && x<=86;
}
export function nearestStarSlot(chart: StarChart, point: {x:number;y:number}, box: {width:number;height:number}, placed: number[]) {
  if(box.width<=0 || box.height<=0) return -1;
  let best=-1, distance=32;
  chart.stars.forEach((star,id) => {
    if(placed.includes(id)) return;
    const gap=Math.hypot((star.x-point.x)*box.width/100,(star.y-point.y)*box.height/100);
    if(gap<distance) { distance=gap; best=id; }
  });
  return best;
}

export interface StarQuestState {
  round: number; phase:"search"|"observe"|"assemble"|"complete";
  found:number[]; placed:number[]; completed:number[]; misses:number;
}
export type QuestAction = {type:"found";id:number} | {type:"place";star:number;slot:number}
  | {type:"observe"|"assemble"|"next"|"retry"|"reset"};
export function createStarQuest(): StarQuestState {
  return {round:0,phase:"search",found:[],placed:[],completed:[],misses:0};
}
export function questReducer(state: StarQuestState, action: QuestAction): StarQuestState {
  const size=starCharts[state.round].stars.length;
  switch(action.type) {
    case "found":
      if(state.phase!=="search" || !Number.isInteger(action.id) || action.id<0 || action.id>=size || state.found.includes(action.id)) return state;
      return {...state,found:[...state.found,action.id]};
    case "observe":
      return state.phase==="assemble" || (state.phase==="search" && state.found.length===size) ? {...state,phase:"observe"} : state;
    case "assemble": return state.phase==="observe" ? {...state,phase:"assemble"} : state;
    case "place": {
      if(state.phase!=="assemble" || !state.found.includes(action.star) || state.placed.includes(action.star)) return state;
      if(action.star!==action.slot) return {...state,misses:state.misses+1};
      const placed=[...state.placed,action.star], complete=placed.length===size;
      return {...state,placed,phase:complete?"complete":"assemble",completed:complete?[...new Set([...state.completed,state.round])]:state.completed};
    }
    case "next": return state.phase==="complete" && state.round<starCharts.length-1
      ? {...createStarQuest(),round:state.round+1,completed:state.completed} : state;
    case "retry": return {...createStarQuest(),round:state.round,completed:state.completed};
    case "reset": return createStarQuest();
  }
}
